var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',[_c('li',{staticClass:"text"},[_vm._l((_vm.productSpecs),function(item){return [(item.content)?_c('RPHAccordion',{key:item.id,attrs:{"open":true,"id":item.hash,"product-accordion":true,"title":item.title,"content":item.content,"hash":item.hash,"tag":'h3'}}):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }